import React from 'react'

import { Spinner } from '@acorns/web-components'

import Button from 'components/Button'
import ETFDoughnut from 'components/charts/ETFDoughnut'
import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { TestIDs } from 'test/utils/testIds'

import { Props, enhance } from './enhance'
import { FinePrint, GraphContainer, Subtitle, Title } from './styled-components'

const colors = ['#363f41', '#466480', '#3073b1', '#3588d7', '#5ca2e4', '#8fc6fa', '#c2dbf3']

const NextButton = withClickTrack<any, any>(TRACKER_IDS.PORTFOLIO_OVERVIEW.SUBMIT_BUTTON)(Button)

const renderHeader = (portfolioName: string): JSX.Element => (
  <>
    <Title data-testid={TestIDs.PORTFOLIO_OVERVIEW.TITLE}>{portfolioName} Portfolio</Title>
    <Subtitle data-testid={TestIDs.PORTFOLIO_OVERVIEW.BODY}>
      We selected this portfolio based on your answers and goals. Your investments will be
      automatically diversified across the categories below, so all your eggs aren't in one basket.
    </Subtitle>

    <FinePrint>You can change this later.</FinePrint>
  </>
)

export const PortfolioOverview: React.FC<Props> = ({
  handleClick,
  loading,
  portfolioName,
  values,
  isSubmitting,
  userPortfolio,
}) => (
  <>
    <Nav />
    <Layout>
      <GraphContainer>
        {loading ? (
          <Spinner />
        ) : (
          <ETFDoughnut
            graphData={values}
            colors={colors}
            portfolio={userPortfolio}
            header={renderHeader(portfolioName)}
          />
        )}
      </GraphContainer>
      {!loading && (
        <>
          <Separator />

          <NextButton disabled={isSubmitting} onPress={handleClick}>
            {isSubmitting ? <Spinner height={20} width={20} white /> : 'Next'}
          </NextButton>
        </>
      )}
    </Layout>
  </>
)

export default enhance(PortfolioOverview)
